module.exports = __webpack_public_path__ + "static/media/anatomia2.c07213d6.png";